module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia7_thumb-1339c8d72da3c66e2114a5102a95dcbc.jpg";